<template>
    <div class="page bgF6F6F6 lineHeight1p375">

        <div class="imageArea" style="height: 255px;">
            <img class="block fullSpace" :src="dataItem ? dataItem.coverImg : ''"/>
        </div>

        <div class="prepayInfo" style="height: 62px; background: url('second_kill/second_kill_price_bar.png') 0 0 no-repeat;
            background-size: 100% 100%; background-size: cover;">
            <div class="paddingH12 flexLayout">
                <div class="flexItem" style="color: #FFF5F5; ">
                    <div class="f12" style="    line-height: 26px; padding-top: 7px;">
                        秒杀价
                        ￥<span style="font-size: 233.3%">{{dataItem ? dataItem.seckillActivityInfo.seckillPrice || 0 : 0}}</span>
                    </div>
                    <div>
                        <span class="textDelete font12r">原价 ￥{{dataItem ? dataItem.marketPrice || 0 : 0}}</span>
                    </div>
                </div>
                <div class="flexItem timeCountDown f12 alignR fWeight600 white" style="padding-top: 8px;"
                     v-show="getActivityStatus() === 'ready' || getActivityStatus() === 'march'">
                    <div v-show="getActivityStatus() === 'ready'">距秒杀开始仅剩</div>
                    <div v-show="getActivityStatus() === 'march'">距秒杀结束仅剩</div>
                    <div class="bold">
<!--                        {{countDown.day}}天-->
                        <span class="textLabel f14">{{countDown.hour}}</span>
                        <span class="paddingH4">:</span>
                        <span class="textLabel f14">{{countDown.minute}}</span>
                        <span class="paddingH4">:</span>
                        <span class="textLabel f14">{{countDown.second}}</span>
                    </div>
                </div>
                <div v-show="getActivityStatus() === 'closed'">
                    活动已结束
                </div>
            </div>
        </div><!-- end .prepayInfo -->

        <div class="white_bg paddingH16 paddingV20 marginB12" v-if="dataItem">
            <div class="title bold marginB4">{{dataItem.title}}</div>
            <div class="clearfix marginB20">
                <div class="floatL">
                    <label class="textLabel" v-show="dataItem.seckillActivityInfo.residueCount">
                        仅剩{{dataItem.seckillActivityInfo.residueCount}}个名额
                    </label>
                    <label class="textLabel" v-show="!dataItem.seckillActivityInfo.residueCount">
                        数量有限，欲购从速
                    </label>
                </div>

            </div>
            <div class="clearfix marginT20">
                <div class="floatL font12r grey60 fWeight600">
                    已更新{{dataItem.liveRecorded}}/共{{dataItem.liveCount}}节课
                </div>
                <div class="floatR f12 grey20 fWeight600" style="line-height: 16px;">
                    {{dataItem && dataItem.seckillActivityInfo.limit ?
                    dataItem.seckillActivityInfo.limit - dataItem.seckillActivityInfo.residueCount :
                    '0'}}人已抢
                </div>
            </div>

        </div>

        <div class="white_bg">
            <div class="tabComp">
                <div class="header">
                    <ul class="menu clearfix noPadding noMargin noListStyle color999 font14r bold">
                        <li class="item" :class="{active : tab.active === '详情'}" @click="tab.active = '详情'">详情</li>
                        <li class="item" :class="{active : tab.active === '课程列表'}" @click="tab.active = '课程列表'">课程列表</li>
                    </ul>
                </div>
                <div class="body">
                    <div class="inner">
                        <!-- 详情内容 -->
                        <div class="article detailContent" v-show="tab.active === '详情'">
                            <div class="alignJustify" v-html="dataItem ? dataItem.introduce : ''"></div>

                            <!--购买须知-->
                            <div class="buyNotice introduction bgF9F9F9 roundBorder4">
                                <div class="title relative fWeight600" style="font-size: 100%">购买须知</div>
                                <div class="padding16 lineH20r12 color999 font12r fWeight600">
                                    <p>1、课程性质：该课程为年付费系列课程，按课程计划定期更新。</p>
                                    <p>2、提供回放：在有效期内，提供回放。</p>
                                    <p>3、退款说明：该课程为虚拟内容服务，购买成功后不支持退换，敬请原谅。</p>
                                    <p>4、版权保护：严禁录制与传播课程视频，违法必究。</p>
                                    <p>5、更多帮助：在“我的”个人中心查看“联系师讯”，咨询师讯相关教务。</p>
                                </div>
                            </div>
                            <!--购买须知END-->
                        </div><!-- end .detailContent -->

                        <!-- 课程列表 -->
                        <div class="sectionListContent" v-show="tab.active === '课程列表'">
                            <ul class="sectionList noPadding noMargin noListStyle">
                                <li class="item flexLayout flex-between" v-for="segmentItem in (dataItem ? dataItem.segmentList : [])"
                                    :key="segmentItem.id" :data-id="segmentItem.id"
                                    :data-scheduleTime="segmentItem.scheduleTime" @click="viewSegment(segmentItem)">
                                    <div class="segmentInof flex-item">
                                        <div class="title bold">
                                            {{segmentItem.title}}
                                        </div>
                                        <div class="time line1 font10r">
                                            时长{{formatDateSegmentLength(segmentItem.videoLength)}}
                                            <span style="display: none; margin-left: 24px">
                                                {{segmentItem.click}}次播放
                                            </span>
                                        </div>
                                    </div>

<!--                                    <img class="vod fr size28" src="icon/grey_circle_play_button.svg">-->

                                </li>
                            </ul>
                        </div><!-- end .sectionListContent -->
                    </div>
                </div>
            </div>
        </div>
<!-- //按键显示 -->
<!-- start -->
  <!-- 文哥写      <div class="bottomOperationArea" v-show="dataItem && !dataItem.seckillActivityInfo.isPay">
            <div class="inner paddingH16 flexLayout">
                <div class="flexItem" v-show="dataItem && !dataItem.seckillActivityInfo.isPay && !user.isVip">
                    <button class="button block openVipButton"
                        style="background-image: url(second_kill/open_vip_button.png)"
                        @click="goToOpenVip()"></button>
                </div>
                <div style="flexItem"> -->
<!--                    <button class="button block bookButton white f16"-->
<!--                        v-show="getActivityStatus() === 'ready'">活动未开始</button>-->
              <!-- 文哥写      <button class="button block bookButton white f16" style="background-image: url(second_kill/buy_button.png)"
                        v-show="getActivityStatus() === 'march' && !dataItem.seckillActivityInfo.isPay" @click="goToBuy">立即抢购</button> -->
<!--                    <button class="button block bookButton white f16"-->
<!--                        v-show="getActivityStatus() === 'march' && dataItem.seckillActivityInfo.isPay" @click="goToLearn()">已购买</button>-->
<!--                    <button class="button block bookButton white f16"-->
<!--                        v-show="getActivityStatus() === 'closed'" disabled="">活动已结束</button>-->
               <!-- 文哥写 </div>
            </div>
        </div> -->


        <div class="bottomOperationArea" v-if="dataItem && !dataItem.isAuthorized && !dataItem.seckillActivityInfo.isPay">
            <div class="inner paddingH16 flexLayout" v-if="user && user.isVip === 1">
                <button class="button block bookButton white f16" style="width:100%;background-image: url(second_kill/second_kill_isvip.png)"
                        v-show="getActivityStatus() === 'march' && !dataItem.isAuthorized && !dataItem.seckillActivityInfo.isPay" @click="goToBuy">
                    立即抢购
                </button>
            </div>
            <div class="inner paddingH16 flexLayout" v-else>
                 <div class="flexItem" v-show="dataItem && !dataItem.isAuthorized &&
                    !dataItem.seckillActivityInfo.isPay && user && user.isVip === 0">
                    <button class="button block openVipButton"
                        style="background-image: url(second_kill/open_vip_button.png)"
                        @click="goToOpenVip()"></button>
                </div>
                <div style="flexItem">
<!--                    <button class="button block bookButton white f16"-->
<!--                        v-show="getActivityStatus() === 'ready'">活动未开始</button>-->
                    <button class="button block bookButton white f16" style="background-image: url(second_kill/buy_button.png)"
                        v-show="getActivityStatus() === 'march' && !dataItem.isAuthorized && !dataItem.seckillActivityInfo.isPay" @click="goToBuy">立即抢购</button>
<!--                    <button class="button block bookButton white f16"-->
<!--                        v-show="getActivityStatus() === 'march' && dataItem.seckillActivityInfo.isPay" @click="goToLearn()">已购买</button>-->
<!--                    <button class="button block bookButton white f16"-->
<!--                        v-show="getActivityStatus() === 'closed'" disabled="">活动已结束</button>-->
                </div>
            </div>
        </div>




        <!-- end -->

        <a class="fixedBackIcon" href="javascript:;" @click="back()">
            <img class="icon" src="icon/back_icon.svg"/>
        </a>
        <a class="fixedShareIcon" href="javascript:;" @click="share()">
            <img class="icon" src="icon/white_circle_share_icon.svg"/>
        </a>

        <coursePayDialog ref="payDialog" type="secondKill" :onPaySuccess="onPaySuccess"/>

    </div><!-- end .page -->
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import moment from 'moment/moment';

// modules
import coursePayDialog from '@comp/vodCourse/coursePayDialog';

//data
import bizTypeEnum from '@/data/bizTypeEnum';

// api
import timerManager from '@comp/platformApi/timerManager';

// util
import consoleHelper from '@util/consoleHelper';
import wechatHelper from '@util/wechatHelper';
import appHelper from '@util/appHelper';

// testing id: 085ab6cacf6848d5b81ac8f6176b1eb9

const config = {
    apiConfig : {
        get : {
            url : '/portal/vod/v2/',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "courseSecondKillDetail",
    extends : shixunPagePart,
    components : {
        coursePayDialog,
    },
    data () {
        return {
            apiConfig : config.apiConfig,
            tab : {
                active : '详情'
            },
            timer : null,
            countDown : {
                day : 0,
                hour : 0,
                minute : 0,
                second : 0,
            },
            user : null
        }
    },
    methods : {
        back: function() {
            appHelper.back(this)
        },
        share() {
            appHelper.shareAlert();
        },
        onLoadDataItem() {

            const me = this;
            if (this.dataItem.isAuthorized || this.dataItem.seckillActivityInfo.isPay)
            {
                appHelper.showHint('已购买，跳转到播放页。');
                timerManager.setTimeout(() => {
                    me.goToLearn();
                });
                return;
            }


            this.setWechatShare();

            let timeRange = '活动时间：';
            timeRange += moment(this.dataItem.seckillActivityInfo.startTime).format('YYYY-MM-DD HH:mm:ss');
            timeRange += ' 至 ';
            timeRange += moment(this.dataItem.seckillActivityInfo.endTime).format('YYYY-MM-DD HH:mm:ss');
            consoleHelper.log(timeRange);



            if (this.inActivityTimeRange())
            {
                this.initTimer();
            }
        },
        goToLearn() {
            appHelper.redirect('/learn/course/' + this.dataItem.id)
        },
        formatDateYMD : function (timestamp) {
            return moment(timestamp).format('YYYY.MM.DD');
        },
        formatDateMD : function (timestamp) {
            return moment(timestamp).format('MM.DD');
        },
        formatDateSegmentLength(seconds) {
            let second = seconds % 60;
            let minute = (seconds - second) / 60;
            let txt = minute + '分' + second + '秒';
            return txt;
        },
        viewSegment(segmentItem) {

            if (this.dataItem.pay)
            {
                appHelper.redirect('/learn/course/' + segmentItem.id)
            }
            else
            {
                appHelper.showHint('购买立即查看');
            }
        },
        initTimer() {
            const me = this;
            this.timer = timerManager.setInterval(() => {
                me.updateCountDown();
            }, 300);
        },
        /**
         * @return {string} 'ready'|'march'|'closed'
         */
        getActivityStatus() {
            if (!this.dataItem) // not loaded data
            {
                return 'ready';
            }

            let nowSeconds = new Date().getTime();

            if (nowSeconds < this.dataItem.seckillActivityInfo.startTime)    // 未开始
            {
                return 'ready';
            }
            if (nowSeconds < this.dataItem.seckillActivityInfo.endTime)    // 进行中
            {
                return 'march';
            }
            else
            {
                return 'closed';
            }
        },
        /**
         * @return {boolean}
         */
        inActivityTimeRange() {
            return this.getActivityStatus() === 'march';
        },
        updateCountDown() {

            // seconds
            let now = new Date().getTime();
            let seconds = 0;
            if (now < this.dataItem.seckillActivityInfo.startTime)   // 还没开始
            {
                seconds = Math.floor((this.dataItem.seckillActivityInfo.startTime - now) / 1000);
            }
            else if (now <= this.dataItem.seckillActivityInfo.endTime)    // 活动进行中
            {
                seconds = Math.floor((this.dataItem.seckillActivityInfo.endTime - now) / 1000);
            }
            else    // 已结束
            {
                this.countDown.second =
                this.countDown.minute =
                this.countDown.hour =
                this.countDown.day = '00';
                return;
            }

            this.countDown.second   = seconds % 60;
            this.countDown.minute   = Math.floor(seconds / 60) % 60;
            this.countDown.hour     = Math.floor(seconds / 60 / 60) % 24;
            this.countDown.day      = Math.floor(seconds / 60 / 60 / 24);

            // fix
            this.countDown.second >= 10 ? null : this.countDown.second = '0' + this.countDown.second;
            this.countDown.minute >= 10 ? null : this.countDown.minute = '0' + this.countDown.minute;
            this.countDown.hour >= 10 ? null : this.countDown.hour = '0' + this.countDown.hour;
            this.countDown.day >= 10 ? null : this.countDown.day = '0' + this.countDown.day;

            // consoleHelper.log(this.countDown.day + ' day ' +
            //     this.countDown.hour + ' hour ' +
            //     this.countDown.minute + ' minute ' +
            //     this.countDown.second + ' second'
            // );
        },
        goToBuy : function () {
            this.$refs.payDialog.setProduct({
                id : this.dataItem ? this.dataItem.seckillActivityInfo.id : '',
                title : this.dataItem ? this.dataItem.title : '',
                image : this.dataItem ? this.dataItem.coverImg : '',
                price : this.dataItem ? this.dataItem.seckillActivityInfo.seckillPrice : '',
                bizType : bizTypeEnum.SECOND_KILL.code
            });
            this.$refs.payDialog.open();
        },
        goToOpenVip : function () {
            let url = '/vip';
            appHelper.redirect(url);
        },
        onPaySuccess : function () {

            const me = this;

            appHelper.showHint('购买成功');

            this.$refs.payDialog.hide();

            // reload data
            window.setTimeout(() => {
                me.loadDataItem(me.dataItem.id);
                appHelper.redirect('/learn/course/' + me.dataItem.id);
            });
        },
        setWechatShare() {

            // let desc = this.dataItem.introduce;
            // desc = htmlHelper.removeTag(desc);
            // desc = htmlHelper.decode(desc);

            let link = '';
            if (!this.user)
            {
                link = appHelper.generateShareUrl('/operationMain/seckill/' + this.dataItem.id);
            }
            else
            {
                link = appHelper.generateShareUrl('/operationMain/seckill/:id/promotion/:promotionCode', {
                    ':id' : this.dataItem.id,
                    ':promotionCode' : this.user.introduceCode
                });
            }

            let title = '秒杀';
            if (this.dataItem.firstCategoryName)
            {
                title += '【' + this.dataItem.firstCategoryName + '】';
            }

            title += this.dataItem.title;

            const wechatShareOptions = {
                title: title, // 分享标题
                desc: '立刻抢购', // 分享描述
                link: link,
                imgUrl: this.dataItem ? this.dataItem.coverImg : appHelper.getAppIcon(), // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
            };

            wechatHelper.setShare(wechatShareOptions);
        }

    },
    /**
     * init processing:
     * load data item -> check login -> set wechat share url
     */
    mounted() {

        const id              = this.$route.params.id || '';
        const promotionCode   = this.$route.params.promotionCode || '';

        const me = this;

        me.loadDataItem(id);

        appHelper.checkLogin(function (error, user)
        {
            if (error)
            {
                return;
            }

            me.user = user;

        }, {
            promotionCode : promotionCode
        });
    },
    beforeRouteLeave : function (to, form, next) {
        if (this.timer)
        {
            timerManager.clearInterval(this.timer);
            this.timer = null;
        }
        next();
    },
    watch: {

        $route (to, from) {

            // 同页面不同参数需要使用函数加载新数据
            if (to.name === from.name)
            {
                const id = to.params.id || '';
                this.$route.params.id = id;

                this.dataItem = {};
                this.loadDataItem(id);
                window.scrollTo(0,0);
            }
            // this.$router.go(0)  // 安卓下会刷新页面，微信下会回到旧地址，苹果下无法跳转
        }
    }
}
</script>

<style lang="scss" scoped>
.textLabel {
    border: solid 1px #F55050;
    color: #F55050;
    background: #FFF5F5;
    padding: 0px 2px;
    font-weight: 600;
}
.tabComp {
    .header {
        .menu {
            .item {
                position: relative;
                float: left;
                padding: 14px 16px;

                &.active {
                    color: #333;

                    &:before {
                        content : '';
                        display: block;
                        position: absolute;
                        width: 18px;
                        height: 2px;
                        background: #F55050;
                        bottom: 6px;
                        left: 50%;
                        margin-left: -9px;
                    }
                }
            }
        }
    }
    .body {
        .inner {
            padding: 16px 18px;
        }
    }
}

.introduction {
    padding: 10px 0 18px;
}
.introduction .title {
    position: relative;
    padding-left: 12px;
}
.introduction .title:before {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    height: 14px;
    background: #F55050;
    top: 5px;
    left: 0;
}
.introduction p {
    margin-bottom: 12px;
}
.timeCountDown .textLabel {
    background-color: hsla(351, 100%, 60%, 1);
    border: none;
    color: white;
    padding: 0 2px;
    text-align: center;
    min-width: 24px;
    line-height: 24px;
    height: 24px;
}
.detailContent {
    display: block;
    overflow: hidden;
    img {
        max-width: 100%;
    }
}

.sectionListContent {
    .sectionList {
        margin-top: .1rem;
        .flex-item {
            flex: 1;
        }
        .item {
            position: relative;
            padding: 10px 12px;
            background-color: #F9F9F9;
            border-radius: 4px;
            margin-bottom: 8px;

            &:last-child {
                border-bottom: 0
            }

            .title {
                /*width: 14rem;*/
                margin-bottom: .3rem;
                overflow: hidden;
                line-height: 1.5em;
                max-height: 3em;
                padding-right: 10px;
            }
            &.active .title {
                color: #0097FE;
                font-weight: 500
            }
            .time {
                color: #888
            }
            .tryBtn span {
                display: inline-block;
                padding: 5px 8px;
                color: #fff;
                border-radius: 4px;
                background-color: #1090FF
            }
        }
    }
}
.bottomOperationArea {

    height: 82px;
    width: 100%;
    box-sizing: border-box;

    .inner {
        position: fixed;
        height: 82px;
        width: 100%;
        left: 0;
        bottom: 0;
        background-color: white;
        box-sizing: border-box;
        padding-top: 3px;
    }

    .label {
        vertical-align: top;
    }
}
.openVipButton {
    width: 46.67vw;
    height: 24.8vw;
    background-size: 100% 100%;
    margin-top: -15px;
    background-color: transparent;
}
.bookButton {
    /*width: 209px;*/
    display: block;
    width: 46.67vw;
    height: 24.8vw;
    text-indent: -9999pt;
    /*background: linear-gradient(169deg, #FF6434 0%, #FF3452 100%);*/
    background-color: transparent;
    background-size: 100% 100%;
    margin-top: -15px;
    /*border-radius: 21px;*/
    border: none;
}

</style>
